import { useEffect, useState } from "react";
import { useFetch } from "../async";
import PropTypes from "prop-types";
import { showNotification } from "react-admin";

const useFetchSettings = (settingKey = "") => {
  const [settings, setSettings] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSettings = async () => {
      setIsLoading(true);
      try {
        // throw new Error("Simulated error for testing");
        const { json } = await useFetch(
          `/api/admin/settings`,
          {
            method: "get",
            resourceApi: "settings",
          },
          showNotification
        );

        if(settingKey){
          setSettings(
            json?.filter((item) => item.setting.includes(settingKey))
          );
        } else {
          setSettings(json);
        }

        setIsLoading(false);
      } catch (error) {
        showNotification("settings not found in useFetchSettings", "error");
        setError(error);
        setIsLoading(false);
      }
    };
    fetchSettings();
  }, [settingKey]);

  return { settings, isLoading, error };
};

useFetchSettings.propTypes = {
  key: PropTypes.string,
};

export default useFetchSettings;
